export default __webpack_public_path__ + "static/media/nested-bullet.0c1c4352.svg";